import {action, computed, observable} from 'mobx';
import {BaseStore} from './base';
import {crmCountUnread} from '../helpers/api/crm';

export class CrmStore extends BaseStore {
  @observable isLoading = false;
  @observable total = { leads: 0 };

  @action async load() {
    if (this.isLoading) {
      return ;
    }

    this.isLoading = true;
    const res = await crmCountUnread({});
    this.isLoading = false;

    if (res) {
      this.total = res;
    }
  }

  @action incrementRead(type, val = 1) {
    this.total[type] = this.total[type] + val;
  }

  @computed get totalUnreadAll() {
    return (this.total && this.total.leads) ? this.total.leads : 0;
  }
}



// WEBPACK FOOTER //
// ./src/stores/crm.js